module.exports = __webpack_public_path__ + "static/media/img_music2.c066be84.png";